//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('checkIn', {
//        templateUrl: 'views/components/views/checkIn/checkIn.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'checkInService', function ($stateParams, stateService, utilityService, checkInService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;
//            let checkInKeyno = $stateParams.checkin_keyno;

//            vm.model = {
//                bgCheckInPersonTypeSelection: {
//                    selected: 'CHECKIN_PERSONTYPE_EXTERNAL',
//                    buttons: [
//                        { id: 'CHECKIN_PERSONTYPE_EXTERNAL', label: 'checkin_persontype_external', color: 'primary', onClick: () => vm.model.bgCheckInPersonTypeSelection.selected = 'CHECKIN_PERSONTYPE_EXTERNAL' },
//                        { id: 'CHECKIN_PERSONTYPE_PERSON', label: 'checkin_persontype_person', color: 'primary', onClick: () => vm.model.bgCheckInPersonTypeSelection.selected = 'CHECKIN_PERSONTYPE_PERSON' }
//                    ]
//                },
//                externalCellPhoneButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.external_cellphone = '' },
//                    { id: '$phone' }
//                ],
//                edit: {},
//                itemsListSkillsCertificates: [],
//                lockedSave: false,
//                lockedCheckInOut: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTIONS

//            async function loadEdit() {
//                vm.model.edit = (await checkInService.getEdit({
//                    argtype: argType,
//                    argvalue: argValue,
//                    checkin_keyno: checkInKeyno
//                }))[0];
//            }

//            async function loadCheckInSkillsCertificates() {
//                if (utilityService.validateParmsValue(vm.model.edit.labour_no) !== true) return;

//                return vm.model.itemsListSkillsCertificates = await checkInService.listCheckInSkillsCertificates({ labour_no: vm.model.edit.labour_no });
//            }

//            // #endregion LOAD PROCEDURE FUNCTIONS

//            // #region BUTTON GROUP SINGLE FUNCTION

//            vm.selectBgCheckInPersonTypeSelection = function (value) {
//                vm.model.bgCheckInPersonTypeSelection.selected = value;
//            }

//            // #endregion BUTTON GROUP SINGLE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                checkInService.saveObj(vm.model.edit).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON CHECK IN AND OUT PROCEDURE FUNCTION CALL

//            vm.checkInOut = function () {
//                vm.model.lockedCheckInOut = true;

//                checkInService.checkInOutOther(vm.model.edit).then(() => {
//                    vm.model.lockedCheckInOut = false;
//                    stateService.back();
//                }, () => vm.model.lockedCheckInOut = false);
//            }

//            // #endregion BUTTON CHECK IN AND OUT PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadEdit();
//                loadCheckInSkillsCertificates();
//            }

//            // #endregion ON INIT FUNCTION

//		}]
//	});
//})();
